<template>
  <div>
    <div v-for="(stat, index) in stats" :key="index" class="faded_border_bottom">
      <p>{{ time_helper.convertDecimalHoursToTime(stat.effort_time) }}</p>
      <stat-resources v-if="stat.resources" :payload="{ stat, show_details: true }"></stat-resources>
    </div>
  </div>
</template>
<script>
import TimeHelper from '@/custom/classes/time_helper.js'
import StatResources from '@/components/StatResources'
export default {
  name: 'resource-effort',
  props: ['payload'],
  data () {
    return {
      time_helper: new TimeHelper(),
      stats: this.payload.effort.stats
    }
  },
  created () {
    this.stats.sort((a, b) => {
      return b.effort_time - a.effort_time
    })
  },
  components: {
    StatResources
  }
}
</script>
